export default __webpack_public_path__ + "static/media/failed.3f1dad54.png";